var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.13809 10.5075L8.49563 10.8651C9.91386 12.2833 11.3309 13.7004 12.7491 15.1186C13.3903 15.7598 14.2044 15.8825 14.891 15.4629C15.8493 14.8788 15.9853 13.6368 15.157 12.7942C13.8996 11.5154 12.6197 10.2569 11.3504 8.98759L10.5066 8.1438L10.8642 7.7862C12.2624 6.38797 13.6606 4.98975 15.0589 3.59153C15.7061 2.94427 15.8659 2.21958 15.5346 1.53307C15.0258 0.47352 13.6849 0.255519 12.8183 1.11019C11.3724 2.5394 9.942 3.9865 8.50444 5.42406L8.15519 5.77331L7.82148 5.43961C6.39133 4.00946 4.96713 2.58526 3.53936 1.15749C2.81713 0.435259 1.84097 0.374558 1.16154 0.984871C0.395083 1.67505 0.384261 2.72988 1.15893 3.5117C2.58312 4.94782 4.01924 6.37201 5.44105 7.79382L5.78786 8.14064L5.43741 8.49109C3.97959 9.94891 2.51581 11.4008 1.06395 12.8646C0.776258 13.149 0.60355 13.5295 0.578884 13.9332C0.554219 14.337 0.679327 14.7357 0.93026 15.0529C1.16235 15.3535 1.49138 15.5643 1.86142 15.6497C2.23145 15.7351 2.61966 15.6896 2.96003 15.5211C3.21547 15.3761 3.44838 15.1946 3.65138 14.9823C5.01742 13.6306 6.36915 12.2646 7.72685 10.9069L8.13809 10.5075Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossBlack);
export default __webpack_public_path__ + "static/media/cross-black.478576e0603e06b118635d3788e0d177.svg";
export { ForwardRef as ReactComponent };